<template>
  <div>
    <vx-card no-shadow>
      <div>
        <h4>Guest Personal information sources</h4>
        <p class="text-sm">For each of the PII fields a table is listed, providing the source and timestamp of how the PII was collected</p>
      </div>

      <div v-if="isLoading" class="flex justify-center">
        <Loading />
      </div>
      <div v-else>
        <div class="mt-4">
          <div v-for="source in sources" :key="source.title">
            <vs-collapse>
              <vs-collapse-item>
                <div slot="header">
                  <div class="flex items-center gap-4 mb-2">
                    <h4>{{ source.title }}</h4>
                    <p v-if="source.current" class="text-sm">Current: {{ source.current }}</p>
                    <p v-else class="italic text-sm">Current: No value</p>
                  </div>
                </div>
                <vs-table :data="source.sources" v-if="source.sources">
                  <!-- <template slot="header">
              </template> -->
                  <template slot="thead">
                    <vs-th> When </vs-th>
                    <vs-th> Where </vs-th>
                    <vs-th> Entity identifier </vs-th>
                    <vs-th> Value provided </vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>{{ tr.timestamp | formatDate }}</vs-td>
                      <vs-td>{{ tr.type }}</vs-td>
                      <vs-td>{{ tr.entityName }} ({{ tr.entityId }})</vs-td>
                      <vs-td>{{ tr.rawValue }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fieldSources: null,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      activeCountryId: "venues/activeCountryId"
    }),
    sources() {
      if (this.fieldSources == null) return [];
      return [
        {
          title: "First name",
          current: this.userProfile.firstName,
          sources: this.fieldSources.firstNameSources
        },
        {
          title: "Last name",
          current: this.userProfile.lastName,
          sources: this.fieldSources.lastNameSources
        },
        {
          title: "Email",
          current: this.userProfile.email,
          sources: this.fieldSources.emailSources
        },
        {
          title: "Phone",
          current: this.userProfile.formattedPhone,
          sources: this.fieldSources.phoneSources
        },
        {
          title: "Birth date",
          current: this.userProfile.birthDate ? moment(this.userProfile.birthDate).format("DD-MM-yyyy") : null,
          sources: this.fieldSources.birthDateSources
        }
      ];
    }
  },
  async created() {
    this.profileId = this.$route.params.id;
    this.isLoading = true;

    const result = await this.$store.dispatch("userProfiles/getUserProfileFieldSources", {
      country: this.activeCountryId,
      userId: this.profileId
    });
    console.log("Field sources result", result);
    this.fieldSources = result;
    this.isLoading = false;
  }
};
</script>


<style lang="scss" scoped>
.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>